/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const notificationTemplates = sqliteTable('notification_templates', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  channel: text('channel'),
  key: text('key'),
  provider_name: text('provider_name'),
  provider_template_name: text('provider_template_name'),
  language_code: text('language_code'),
  category: text('category'),
  description: text('description'),
  active: integer('active'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
